console.log('%c👍🏼 Video Autoplay', 'color: yellow');
const videos = document.querySelectorAll('.video-autoplay');
videos.forEach(function(video) {
    let observer = new IntersectionObserver((entries, observer) => { 
        entries.forEach(entry => {
        if(entry.intersectionRatio!=1 ){
            video.pause();
        }
        else  {
            video.play(); 
        }
        });
    }, {threshold: 1});
    observer.observe(video);
});